<ng-template #submitMeasurementsTemplate>
	@if ({ assignedClientProgressTypes: assignedClientProgressTypes(), allProgressTypes: allProgressTypes() }; as data)
	{ @if (data.allProgressTypes && data.assignedClientProgressTypes) {
	<mod-submit-progress-measurements
		[assignedUserProgressTypes]="data.assignedClientProgressTypes"
		[allProgressTypes]="data.allProgressTypes"
		[isInDialog]="true"
		(save)="handleSaveProgress($event)"
	></mod-submit-progress-measurements>
	} }
</ng-template>

<ng-template #newProgressTypeTemplate>
	<mod-progress-type-form (create)="handleCreateProgressType($event)" [isInDialog]="true"></mod-progress-type-form>
</ng-template>

@if (mainButtons(); as mainButtons) { @if (mainButtons.length) {
<div class="push-bottom">
	<lib-button-list [buttons]="mainButtons"></lib-button-list>
</div>
} } @if (assignedProgressTypeListItems(); as assignedProgressTypeListItems) {
<div>
	@if (assignedProgressTypeListItems.length) {
	<div>
		<lib-card
			[title]="'Assigned progress types'"
			[subtitle]="'Track progress by submitting measurements periodically'"
		>
			@if (measurementButtons(); as measurementButtons) {
			<div class="push-bottom">
				<lib-button-list [buttons]="measurementButtons" [mode]="'list'"></lib-button-list>
			</div>
			} @if (!isMobileView()) { @if (tableDataRows(); as tableDataRows) {
			<div>
				<ng-container>
					<div [libFlexRow]="''" [libFlexRowGap]="'16px'">
						<div libFlexColumn [libFlexSize]="'fill'"></div>
						<div
							libFlexColumn
							class="w-text-center"
							[libFlexSize]="'70px'"
							libText3
							[libTooltip]="'Number of measurements'"
						>
							#
						</div>
						<div
							libFlexColumn
							class="w-text-center"
							[libFlexSize]="'70px'"
							libText3
							[libTooltip]="'Average value'"
						>
							Avg
						</div>
						<div
							libFlexColumn
							class="w-text-center"
							[libFlexSize]="'70px'"
							libText3
							[libTooltip]="'Minimal measured value'"
						>
							Min
						</div>
						<div
							libFlexColumn
							class="w-text-center"
							[libFlexSize]="'70px'"
							libText3
							[libTooltip]="'Maximum measured value'"
						>
							Max
						</div>
						<div libFlexColumn class="w-text-center" [libFlexSize]="'50px'" libText3></div>
					</div>

					<lib-divider class="push-top push-bottom"></lib-divider>

					@for (row of tableDataRows; track row.id; let first = $first) { @if (!first) {
					<lib-divider class="push-top-sm push-bottom-sm"></lib-divider>
					}
					<div [libFlexRow]="false" [libFlexRowGap]="'16px'">
						<div libFlexColumn [libFlexSize]="'fill'">
							<div libText1>
								{{ row.name }}
							</div>
							<div libText4>
								{{ row.unit }}
							</div>
						</div>
						<div
							libFlexColumn
							class="w-text-center"
							[libFlexSize]="'70px'"
							libText3
							[libTooltip]="'Number of measurements'"
						>
							{{ row.measurements }}
						</div>
						<div
							libFlexColumn
							class="w-text-center"
							[libFlexSize]="'70px'"
							libText3
							[libTooltip]="row.unit"
						>
							{{ row.avgValue }}
						</div>
						<div
							libFlexColumn
							class="w-text-center"
							[libFlexSize]="'70px'"
							libText3
							[libTooltip]="row.unit"
						>
							{{ row.minValue }}
						</div>
						<div
							libFlexColumn
							class="w-text-center"
							[libFlexSize]="'70px'"
							libText3
							[libTooltip]="row.unit"
						>
							{{ row.maxValue }}
						</div>
						<div libFlexColumn [libFlexSize]="'50px'">
							<div libFlexRow [libFlexRowAlign]="'end'">
								<div libFlexColumn>
									<lib-button-list [buttons]="row.buttons" [mode]="'single'"></lib-button-list>
								</div>
							</div>
						</div>
					</div>
					}
				</ng-container>
			</div>
			} } @else {
			<lib-list [items]="assignedProgressTypeListItems"></lib-list>
			}
		</lib-card>

		@if (assignedClientProgressTypes(); as assignedClientProgressTypes) {
		<ng-container>
			@if (allProgressTypes(); as allProgressTypes) { @if (allProgressTypes && assignedClientProgressTypes) {

			<lib-divider class="push-top push-bottom" [layout]="'withContent'">Explore progress</lib-divider>

			<mod-progress-graphs
				[displayOverviewTable]="isMobileView()"
				[assignedUserProgressTypes]="assignedClientProgressTypes"
				[allProgressTypes]="allProgressTypes"
			></mod-progress-graphs>
			} } </ng-container
		>}
	</div>
	}
</div>
} @if (assignedProgressTypeListItems()?.length === 0) {
<div>
	<lib-message [type]="'noDataOnBody'">
		@if (authUserIsClient()) { You have no assigned progress types } @else { Client has no assigned progress types }
	</lib-message>
</div>

}
